import { ClassNames } from '@emotion/core';
import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import Chevron from '@ep/images/chevron.svg';
import theme from '@ep/theme';
import { NavItem } from '@ep/types/menuData';
import ExpansionPanel from '@mui/material/Accordion';
import ExpansionPanelSummary from '@mui/material/AccordionSummary';
import React, { useState } from 'react';
import Submenu from './Submenu';

export interface AccordionProps {
  prefix: string;
  data: NavItem[];
  footer?: boolean;
  toggleDrawer: () => void;
}

interface StyledLinkProps {
  expand?: boolean;
  footer?: boolean;
}

const StyledLink = styled(Link)<StyledLinkProps>`
  padding: 1rem 0;
  ${({ expand }) => (expand ? `flex: 1;` : '')}
  ${({ footer }) => (footer ? `color: ${theme.colors.white};` : '')}

  :hover {
    text-decoration: none;
  }
`;

const Accordion = ({ prefix, data, footer, toggleDrawer }: AccordionProps) => {
  const [expandedIndex, setExpandedIndex] = useState<number | undefined>();

  function handleChange(index: number) {
    return () => setExpandedIndex(index === expandedIndex ? undefined : index);
  }

  return (
    <ClassNames>
      {({ css }) =>
        data.map((menu, index) => {
          const submenuCount = menu.submenu?.length ?? 0;

          return (
            <ExpansionPanel
              key={menu.label}
              expanded={submenuCount > 1 && expandedIndex === index}
              onChange={handleChange(index)}
              elevation={0}
              classes={
                footer
                  ? {
                      root: css`
                        background-color: ${theme.colors.footerNav};
                      `,
                    }
                  : undefined
              }
            >
              <ExpansionPanelSummary
                expandIcon={submenuCount > 1 && <Chevron />}
                aria-controls={`${prefix}-menu-${menu.label}-content`}
                id={`${prefix}-menu-${menu.label}-header`}
                classes={
                  footer
                    ? {
                        content: css`
                          color: ${theme.colors.white};
                        `,
                        expandIcon: css`
                          color: ${theme.colors.white};
                        `,
                      }
                    : undefined
                }
              >
                {menu.link || submenuCount === 1 ? (
                  <StyledLink
                    to={menu.link ?? menu.submenu![0].link}
                    expand={submenuCount < 2}
                    footer={footer}
                    onClick={toggleDrawer}
                  >
                    {menu.label}
                  </StyledLink>
                ) : (
                  menu.label
                )}
              </ExpansionPanelSummary>
              {submenuCount > 1 && (
                <Submenu menu={menu} toggleDrawer={toggleDrawer} />
              )}
            </ExpansionPanel>
          );
        })
      }
    </ClassNames>
  );
};

export default React.memo(Accordion);
